// La fecha civil del navegador en formato YYYY-MM-DD — FV-1.
// FIX_HALLAZGOS_DE_VERIFICACION_v0.1.md, F-1
//
// **No usar `new Date().toISOString().slice(0, 10)` para «hoy».** Esa expresión
// da la fecha en UTC, y Paraguay está en -03: entre las 21:00 y la medianoche
// devuelve el día SIGUIENTE. Se veía como un listado de cobros del día vacío o
// un vencimiento que no dejaba elegir hoy, y sólo de noche.
//
// `getFullYear/getMonth/getDate` son locales: dan el día que el operador ve en
// su reloj. Es la única copia de este cálculo (lección de `aFecha`, H-N):
// `todayApi()` de `date.js` delega acá.

const dos = (n) => String(n).padStart(2, '0')

export function fechaIsoLocal (fecha = new Date()) {
  return `${fecha.getFullYear()}-${dos(fecha.getMonth() + 1)}-${dos(fecha.getDate())}`
}

// La misma fecha civil corrida `dias` días (negativo hacia atrás).
export function fechaIsoLocalMasDias (dias, desde = new Date()) {
  const d = new Date(desde)
  d.setDate(d.getDate() + dias)
  return fechaIsoLocal(d)
}
